import DisplayRecord from "./DisplayRecord";
import { Tooltip, Whisper } from "rsuite";
import useFieldMap from "../../hooks/useFieldMap";
import { useMemo } from "react";
import EmptyField from "./EmptyField";
import { CalculatedOutputs } from "../Drawers/Fields/FieldTypeSpecific/FieldTypeCalculated";

interface Props {
  tableView: boolean;
  field: any;
  existingValue: any;
  mode: "r";
  moduleAPIName: string;
}

const CalculatedRecord = ({
  tableView,
  field,
  existingValue,
  mode,
  moduleAPIName,
}: Props) => {
  const fieldTypeMap: { [key: string]: string } = useFieldMap(
    moduleAPIName,
    "FieldType"
  );

  const output = useMemo((): CalculatedOutputs => {
    if (field?.CalculatedFieldData?.Type === "number") {
      if (field?.CalculatedFieldData?.Output) {
        return field?.CalculatedFieldData?.Output;
      } else {
        const calculationFieldAPINames =
          field?.CalculatedFieldData?.FieldAPINames ?? [];

        for (const calculationFieldAPIName of calculationFieldAPINames) {
          if (
            ["Currency", "CurrencyInterval"].includes(
              fieldTypeMap[calculationFieldAPIName]
            )
          ) {
            return "currency";
          }
        }
      }
    }

    return "";
  }, [field, fieldTypeMap]);

  return (
    // @ts-ignore
    <DisplayRecord
      mode={field?.ReadOnly ? "r" : mode}
      tableView={tableView}
      isSensitive={field?.Sensitive ?? false}
      displayComponent={() => (
        <Whisper
          placement="auto"
          speaker={
            <Tooltip>{`${field.Name} = ${
              field.CalculatedFieldData?.PlainText || "Not visible formula"
            }`}</Tooltip>
          }
          trigger="hover"
          // delayOpen={200}
        >
          <div>
            {(existingValue || existingValue === 0) && field ? (
              output === "currency" ? (
                displayAsCurrency(existingValue)
              ) : output === "percentage" ? (
                existingValue + "%"
              ) : (
                existingValue
              )
            ) : (
              <EmptyField table={tableView} />
            )}
          </div>
        </Whisper>
      )}
    />
  );

  function displayAsCurrency(val: string) {
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    });

    return formatter.format(parseFloat(val));
  }
};

export default CalculatedRecord;
